import { render, staticRenderFns } from "./Tracce.vue?vue&type=template&id=1a4c0c86&scoped=true"
import script from "./Tracce.vue?vue&type=script&lang=js"
export * from "./Tracce.vue?vue&type=script&lang=js"
import style0 from "./Tracce.vue?vue&type=style&index=0&id=1a4c0c86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4c0c86",
  null
  
)

export default component.exports